import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {Component, ElementRef, ViewChild, SimpleChanges,OnInit,OnChanges, Input, Output, EventEmitter} from '@angular/core';
import {FormControl} from '@angular/forms';
import {MatAutocompleteSelectedEvent, MatChipInputEvent, MatAutocomplete} from '@angular/material';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';

@Component({
	selector: 'swap-multiselect-list',
	templateUrl: './swap-multiselect-list.component.html',
	styleUrls: ['./swap-multiselect-list.component.scss']
})
export class SwapMultiselectListComponent implements OnInit, OnChanges {
	
	@Input() sourceData;
	@Input() destinationData;
	@Input() displayKey;
	@Input() listTitle1;
	@Input() listTitle2;
	@Input() sortList;
	@Input() isDisable;
	@Input() multiSelect?: String = 'on';
	@Output() finalData = new EventEmitter();

	s_selection = [];
	d_selection = [];

	constructor() {
	}

	ngOnChanges(changes: SimpleChanges){
		if(this.sourceData && this.sourceData.length && this.displayKey && this.sortList) {
			this.sourceData = this.sorting(this.sourceData, this.displayKey);
		}
		if(this.destinationData && this.destinationData.length && this.displayKey && this.sortList) {
			this.destinationData = this.sorting(this.destinationData, this.displayKey);
		}
	}

	ngOnInit(){
	}

	moveDataRight(all?) {
		if(all)
			this.s_selection = [...this.sourceData];

		if(!this.s_selection.length)
			return;
		
		this.s_selection.map( data_1 => {
			this.sourceData.map( (data_2, index) => {
				if(JSON.stringify(data_1) == JSON.stringify(data_2)){
					this.sourceData.splice(index, 1);
					this.destinationData.push(data_2);
				}
			});
		});
		let data = [...this.s_selection];
		this.s_selection = [];
		this.destinationData = this.sorting(this.destinationData, this.displayKey);
		this.finalData.emit({finalData: this.destinationData, action: 'add', movedData: data});
	}

	moveDataLeft(all?) {
		if(all)
			this.d_selection = [...this.destinationData];

		if(!this.d_selection.length)
			return;

		this.d_selection.map( data_1 => {
			this.destinationData.map( (data_2, index) => {
				if(JSON.stringify(data_1) == JSON.stringify(data_2)){
					this.destinationData.splice(index, 1);
					this.sourceData.push(data_2);
				}
			});
		});
		let data = [...this.d_selection];
		this.d_selection = [];
		this.sourceData = this.sorting(this.sourceData, this.displayKey);
		this.finalData.emit({finalData: this.destinationData, action: 'remove', movedData: data});
	}

	sorting(list, sortBy) {
		return list
		//return list.sort((a,b) => (a[sortBy].toLowerCase() > b[sortBy].toLowerCase()) ? 1 : ((b[sortBy].toLowerCase() > a[sortBy].toLowerCase()) ? -1 : 0));
	}


}

